export default "__VITE_ASSET__C648l69a__"